import React from "react";

const AddStory = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    p-id="46516"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M810.666667 42.666667H213.333333a85.333333 85.333333 0 0 0-85.333333 85.333333v768a85.333333 85.333333 0 0 0 85.333333 85.333333h597.333334a85.333333 85.333333 0 0 0 85.333333-85.333333V128a85.333333 85.333333 0 0 0-85.333333-85.333333z m0 853.333333H213.333333V128h597.333334z"
      fill={color}
      p-id="46517"
    ></path>
    <path
      d="M362.666667 682.666667h298.666666a42.666667 42.666667 0 0 0 0-85.333334H362.666667a42.666667 42.666667 0 0 0 0 85.333334zM362.666667 810.666667h149.333333a42.666667 42.666667 0 0 0 0-85.333334h-149.333333a42.666667 42.666667 0 0 0 0 85.333334zM405.333333 405.333333h64v64a42.666667 42.666667 0 0 0 85.333334 0v-64h64a42.666667 42.666667 0 0 0 0-85.333333h-64v-64a42.666667 42.666667 0 0 0-85.333334 0v64h-64a42.666667 42.666667 0 0 0 0 85.333333z"
      fill={color}
      p-id="46518"
    ></path>
  </svg>
);

export default AddStory;
